export default __webpack_public_path__ + "static/media/37_black_painter.25714cf1.png";